module.exports = __webpack_public_path__ + "static/media/supportSingle.c10c6471.JPG";